import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  //----------------------------- Below code is the newer version that uses Backend API ---------------//


  // TransaltionJson: TranslateResource[] = [];
  // constructor(private http: HttpClient) {
  //   this.getTranslationJson().subscribe((res: TranslateResource[]) => this.TransaltionJson = res);
  // }

  // getTranslationJson() {
  //   return this.http.get<TranslateResource[]>('/localization/get-resources');
  // }


  // getTranslationByKey(key: string) {
  //   if (!this.TransaltionJson) {
  //     this.getTranslationJson().subscribe((res: []) => {
  //       this.TransaltionJson = res;
  //       this.getTranslationByKey(key);
  //     })
  //   }
  //   if (this.TransaltionJson) {
  //     let searchKey = this.TransaltionJson.find(y => y.key.toLowerCase() == key.toLowerCase())
  //     if (searchKey) {
  //       return searchKey.value;
  //     } else {
  //       searchKey = this.TransaltionJson.find(y => y.key.toLowerCase() == 'Default_Message'.toLowerCase())
  //       if (searchKey) {
  //         return searchKey.value;
  //       } else {
  //         return "...Something Went Wrong !!...."
  //       }
  //     }
  //   } else {
  //     return "...Something Went Wrong !!...."
  //   }

  // }

  //----------------------------------------------------------------------------------------------------


  // ------------------------------------- below is code 3.7.2 ----------------------------------------
  TransaltionJson: {};
  private _jsonURL = './assets/translateJson.json';
  constructor() {
    fetch(this._jsonURL).then(response => response.json())
      .then(res => {
        console.log('------------');
        this.TransaltionJson = res;
      });
  }


  getTranslationByKey(key: string, culture: string) {
    if (!this.TransaltionJson) {
      return;
    }
    const keys = Object.keys(this.TransaltionJson);
    if (this.TransaltionJson[culture]) {
      if (this.TransaltionJson[culture][key])
        return this.TransaltionJson[culture][key];
      else
        return this.TransaltionJson[culture]['Default_Message'];
    } else if (this.TransaltionJson[0]){
      if (this.TransaltionJson[0][key])
        return this.TransaltionJson[0][key];
      else this.TransaltionJson[0]['Default_Message'];
    }else{
      return "...Something Went Wrong !!...."
    }

  }
}

class TranslateResource {
  key: string;
  value: string;
  siteCultureId: number;
  isTranslated: true;
}
